export default [
    {
        path: '/account/login',
        name: 'Login',
        meta: {
            slidebar: false
        },
        component: (resolve) => require(['./Login.vue'], resolve),

    }
]



// WEBPACK FOOTER //
// ./src/modules/account/router.js